import { useAccountInfo } from '@/hooks/query/account';
import { useTranslations } from 'next-intl';
import { useBookingButtonStatus } from '@/features/betslip/betslip-booking/hooks/use-booking-button-status';
import Image from 'next/image';

export const BookedBetPromoteHint = () => {
	const { user } = useAccountInfo();
	const { isVisible: isBookingButtonVisible } = useBookingButtonStatus();
	const t = useTranslations('General');
	
	const openBookedBetRewardWithCare = () => {
		if (user?.EnableRewardMaintenance) {
			const event = new CustomEvent('open-um');
			document.dispatchEvent(event);
		} else {
			const event = new CustomEvent('open-booked-bet-reward');
			document.dispatchEvent(event);
		}
	};
	const showHint = isBookingButtonVisible && user?.RewardInfo.PromoteBookedBet;
	return showHint ? (
		<div
			className="booked-hint"
			onClick={openBookedBetRewardWithCare}
		>
			<div className="booked-hint__info">
				<div className="booked-hint__title">{t('lbl_BBSBCTips01')}</div>
				<div className="booked-hint__text">{t('lbl_BBSBCTips02')}</div>
			</div>
			<div className="booked-hint__amount">
				<Image src="/images/coin-icon.svg" width={16} height={16} alt="" />
				<div className="booked-hint__amount-text">+100</div>
				<div className="booked-hint__icon-arrow"></div>
			</div>
		</div>
	) : null;
};